import React, { Component, Fragment } from 'react';

import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';

import Card from '../../artzu-ui/src/Card';
import CheckBox from '../../artzu-ui/src/CheckBox';
import Modal from '../../artzu-ui/src/Modal';
import Button from '../../artzu-ui/src/Button';

import Footer from '../NewApply/Footer';

import coins from '../../images/Icons/Coins.svg';
import calendar from '../../images/Icons/Calendar.svg';
import car from '../../images/Icons/Car.svg';

import ScrollLock from 'react-scrolllock';
import EncourageScroll from '../EncourageScroll';

class ConnectWithUber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: props.currentUser.existingUberPartner === false ? 'no' : '',
      checked: false,
      agreeModalOpen: false,
      learnModalOpen: false,
    };
  }

  componentDidMount() {
    const { currentUser, incrementStep } = this.props;
    if (currentUser.accountName) {
      incrementStep();
    }
  }

  select = target => {
    const { selected } = this.state;
    if (target === 'yes') {
      if (selected !== 'yes') {
        this.setState({ selected: 'yes' });
      } else {
        this.setState({ selected: '' });
      }
    } else if (selected !== 'no') {
      this.setState({ selected: 'no' });
    } else {
      this.setState({ selected: '' });
    }
  };

  updateUser = () => {
    this.props.client.mutate({
      mutation: UPDATE_USER,
      variables: {
        userFields: {
          existingUberPartner: false,
        },
      },
    });
  };

  toggleAgreeModal = () => this.setState({ agreeModalOpen: !this.state.agreeModalOpen });

  toggleLearnModal = () => this.setState({ learnModalOpen: !this.state.learnModalOpen });

  toggleCheck = () => this.setState({ checked: !this.state.checked, selected: 'yes' });

  onClick = () => {
    const { selected, checked } = this.state;
    const { uberTerms } = this.props;
    if (selected === 'no') {
      this.updateUser();
      this.props.incrementStep();
    } else if (uberTerms) {
      if (checked) {
        // this.updateUser();
        window.location = this.props.uberUrl;
      } else {
        this.toggleAgreeModal();
      }
    } else {
      this.props.toggleUberTerms();
    }
  };

  render() {
    const { selected, checked, agreeModalOpen, learnModalOpen } = this.state;
    const { currentStep, currentUser, toggleUberTerms, uberTerms, title } = this.props;

    return (
      <Fragment>
        <Modal open={agreeModalOpen}>
          <div className="apply__uber--terms-modal">
            <div className="apply__uber--terms-modal-text">
              {' '}
              You need to agree to the terms before proceeding to the next step.{' '}
            </div>
            <div className="apply__uber--terms-modal-button">
              <Button label="Okay" onClick={() => this.toggleAgreeModal()} />
            </div>
          </div>
        </Modal>
        <Modal open={learnModalOpen}>
          <div className="apply__uber--terms-modal">
            <div className="apply__uber--terms-modal-text">
              {' '}
              In order to provide you a hassle free experience, Autzu receives your Uber earnings so that you do not
              need to pay a deposit or make any upfront payments.{' '}
            </div>
            <div className="apply__uber--terms-modal-button">
              <Button label="Okay" onClick={() => this.toggleLearnModal()} />
            </div>
          </div>
        </Modal>
        <ScrollLock>
          <EncourageScroll className="apply__uber">
            <div className="apply__uber--container">
              <div className="apply__body--title"> {title}</div>
              {!uberTerms ? (
                <Fragment>
                  <div className="apply__body--message">
                    {' '}
                    Do you have an existing Uber Driver account? Please select one of the following.
                  </div>
                  <div className="apply__uber--buttons">
                    <div className="apply__uber--card">
                      <Card width="100%" height="100%" selected={this.state.selected === 'yes'}>
                        <div className="apply__uber--card--container" onClick={() => this.select('yes')}>
                          <div className="apply__uber--card--title"> I have an active Uber Driver account.</div>
                          <div className="apply__uber--card--text">
                            This means you have completed the background check and have picked up passengers before.
                          </div>{' '}
                        </div>
                      </Card>
                    </div>
                    <div className="apply__uber--card">
                      <Card width="100%" height="100%" selected={this.state.selected === 'no'}>
                        <div className="apply__uber--card--container" onClick={() => this.select('no')}>
                          <div className="apply__uber--card--title"> I do not have an active Uber Driver account.</div>
                          <div className="apply__uber--card--text">Don’t worry, we will create one for you.</div>{' '}
                        </div>
                      </Card>
                    </div>
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  <div className="apply__uber--condition-container">
                    <div className="apply__uber--condition">
                      <div className="apply__uber--condition-image">
                        <img alt="condition" src={coins} />
                      </div>
                      <div className="apply__uber--condition--text">
                        {' '}
                        Uber will send your weekly payment to your Autzu account.{' '}
                      </div>
                    </div>
                    <div className="apply__uber--condition">
                      <div className="apply__uber--condition-image">
                        <img alt="condition" src={car} />
                      </div>
                      <div className="apply__uber--condition--text">
                        {' '}
                        Your weekly usage fees are then deducted from your Autzu account.{' '}
                      </div>
                    </div>
                    <div className="apply__uber--condition">
                      <div className="apply__uber--condition-image">
                        <img alt="condition" src={calendar} />
                      </div>
                      <div className="apply__uber--condition--text">
                        {' '}
                        Your net earnings will be automatically sent to your bank account within 24 hours of the weekly
                        Uber payment.{' '}
                      </div>
                    </div>
                  </div>
                  <div className="apply__uber--learn-more">
                    <div onClick={() => this.toggleLearnModal()}> Learn More </div>
                  </div>
                </Fragment>
              )}
            </div>
          </EncourageScroll>
        </ScrollLock>
        <Footer
          currentStep={currentStep}
          currentUser={currentUser}
          back={uberTerms}
          onBackClick={() => {
            toggleUberTerms();
          }}
          active={selected}
          onNextClick={this.onClick}>
          {uberTerms ? (
            <CheckBox checkState={checked} label="I agree to the above." onClick={this.toggleCheck} />
          ) : null}
        </Footer>
      </Fragment>
    );
  }
}

const UPDATE_USER = gql`
  mutation updateUser($userFields: UserAttributes!) {
    updateUser(userFields: $userFields) {
      errors {
        message
      }
    }
  }
`;

export default withApollo(ConnectWithUber);



// WEBPACK FOOTER //
// ./src/components/TorontoApply/ConnectWithUber.js